module.exports = __webpack_public_path__ + "static/media/theme-color-sample2.ef4bbbe2.png";